import { rgba } from 'polished';
import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

interface TwoFactorInputProps {
  className?: string;
  value?: string | number | readonly string[];
  invalid?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

const TwoFactorInput: FunctionComponent<TwoFactorInputProps> = ({
  className,
  value,
  onChange,
  invalid,
}) => {
  const getInputClassName = () => {
    if (value && invalid) {
      return `${className || ''} has-value invalid`;
    } else if (value) {
      return `${className || ''} has-value`;
    } else {
      return `${className || ''}`;
    }
  };
  return (
    <InputContainer className={getInputClassName()}>
      <StyledInput
        value={value}
        maxLength={1}
        minLength={1}
        pattern="[0-9]*"
        required
        onChange={onChange}
      />
    </InputContainer>
  );
};

export default TwoFactorInput;

const StyledInput = styled.input`
  position: absolute;
  inset: 0;
  font-size: 32px;
  font-weight: 700;
  width: 70px;
  height: 60px;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.primary};
  text-align: center;
  appearance: textfield;
`;

const InputContainer = styled.div`
  position: relative;
  width: 70px;
  height: 60px;
  background-color: ${({ theme }) => rgba(theme.colors.lightGray, 0.6)};
  border-radius: 4px;

  &:after {
    position: absolute;
    left: 50%;
    bottom: 5px;
    transform: translate(-50%, 0);
    content: '';
    background-color: ${({ theme }) => theme.colors.tertiary};
    height: 2px;
    width: 14px;
    transition: background-color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
  }

  &.has-value {
    &:after {
      background-color: transparent;
    }

    &.invalid {
      &:after {
        background-color: ${({ theme }) => theme.colors.error};
      }
    }
  }
`;
